// partner 페이지 define

const PartnerType = {
  Consulting: 1, // 컨설팅
  WeddingHall: 2, // 웨딩홀
  Studio: 3, // 스튜디오
  Dress: 4, // 드레스
  Makeup: 5, // 메이크업
  Hanbok: 6, // 한복
  MarryingStuffs: 7, // 혼수
  Yemul: 8, // 예물
  Etc: 9, // 기타
  HouseMoving: 10, // 이사
  WeddingCar: 11, // 웨딩카
  Snap: 12, // 스냅
  Video: 13, // 동영상
  Pyebaek: 14, // 폐백
  FormalDress: 15, // 예복
  Bouquet: 16, // 부케
  MusicPlay: 17, // 연주
  WeddingSong: 18, // 축가
  Honeymoon: 19, // 신혼여행
  Furniture: 20, // 가구
  Invitation: 21, // 청첩장
  Yedan: 22, // 예단
  HomeAppliances: 23, // 가전
  MeetingCeremony: 24, // 상견례
  Coupon: 25, // 쿠폰
  Concierge: 26, // 컨시어지
  HoneymoonHouse: 27, // 신혼집
  GiftInReturn: 28, // 답례품
  Beauty: 29, // 뷰티
  BusAndShuttle: 30, // 버스/셔틀
  DepartmentStore: 31, // 백화점
  Fashion: 32, // 패션
  WeddingBook: 33, // 웨딩북
  HoneymoonDestination: 36, // 신혼여행지
  Planner: 37, // 플래너
  WeddingConsulting: 38, // 웨딩 컨설팅
} as const;

const PartnerTypeName = {
  1: "컨설팅",
  2: "웨딩홀",
  3: "스튜디오",
  4: "드레스",
  5: "메이크업",
  6: "한복",
  7: "혼수",
  8: "예물",
  9: "기타",
  10: "이사",
  11: "웨딩카",
  12: "스냅",
  13: "동영상",
  14: "폐백",
  15: "예복",
  16: "부케",
  17: "연주",
  18: "사회자/축가",
  19: "신혼여행",
  20: "가구",
  21: "청첩장",
  22: "예단",
  23: "가전",
  24: "상견례",
  25: "쿠폰",
  26: "컨시어지",
  27: "신혼집",
  28: "답례품",
  29: "뷰티",
  30: "버스/셔틀",
  31: "백화점",
  32: "패션",
  33: "웨딩북",
  34: "웨딩북 프로",
  35: "COVID19",
  36: "신혼여행지",
  37: "웨딩 플래너",
  38: "웨딩 컨설팅",
};

const PartnerDetailInfoType = {
  Product: 1,
  Brand: 2,
} as const;

const PartnerTabId = {
  Info: 1,
  Photo: 2,
  Review: 3,
  Qna: 4,
  Portfolio: 5,
  Planner: 6,
} as const;

const PartnerTabCodeMap = {
  INFO: PartnerTabId.Info,
  PHOTO: PartnerTabId.Photo,
  REVIEW: PartnerTabId.Review,
  INQUIRY: PartnerTabId.Qna,
  PORTFOLIO: PartnerTabId.Portfolio,
  PLANNER: PartnerTabId.Planner,
} as const;

const PartnerInfoComponentType = {
  // 기존
  BigTitle: "TITLE", // 큰 타이틀
  BigText: "TEXT", // 큰 텍스트
  Benefit: "BENEFIT", // 혜택
  PopularProduct: "PRODUCT", // 인기상품
  Qna: "QNA", // Q&A
  TextBox: "INFO", // 텍스트박스
  Image: "IMAGE", // 이미지
  Table: "TABLE", // 테이블
  Note: "NOTE", // 제목: 작은 타이틀, 내용: 작은 텍스트
  Video: "VIDEO", // 비디오

  // 추가된
  SwipeImage: "SWIPE_IMAGE", //스와이프 이미지
  SmallTitle: "SMALL_TITLE", // 작은 타이틀
  SmallText: "SMALL_TEXT", // 작은 텍스트
  Button1: "BUTTON_1", // 버튼1 - 현재 outlined, round 버튼
  Button2: "BUTTON_2", // 버튼2 - 현재 wide, background 버튼
  Tags: "TAGS", // 태그
  ProductCard: "PRODUCT_CARD", // 상품 카드
  BulletText: "BULLET_TEXT", // 불릿 텍스트
  Divider: "DIVIDER", // 구분선
  LocationInfo: "LOCATION_INFO", // 위치정보
  ConsultingCompany: "CONSULTING_COMPANY", // 소속 컨설팅

  // 더보기
  Magazine: "MAGAZINE", // 매거진
  RelatedPartner: "RELATED_PARTNER", // 다른 고객이 함께 본 업체
  RecommendationPartner: "RECOMMENDATION_PARTNER", // 당신을 위한 업체 추천
};

export {
  PartnerType,
  PartnerTypeName,
  PartnerDetailInfoType,
  PartnerTabId,
  PartnerTabCodeMap,
  PartnerInfoComponentType,
};
